import Pqp from "../../../../../3x1010/Pqp.js";
import Maze from "../../../../maze/Maze.js";
import Decision from "./Decision.js";

export default class TrackHero extends Decision {
	constructor(initer) {
		super(initer);
		this.endCell = initer.cell;
		this.traveled = 0;
		this.destroyed = false;
	}

	init() {
		this.startCell = this.mob.cell;
		this.dir = Maze.DIR_N;
		if (this.startCell.row + 1 === this.endCell.row) {
			this.dir = Maze.DIR_S;
		} else if (this.startCell.row - 1 === this.endCell.row) {
			this.dir = Maze.DIR_N;
		} else if (this.startCell.col + 1 === this.endCell.col) {
			this.dir = Maze.DIR_E;
		} else if (this.startCell.col - 1 === this.endCell.col) {
			this.dir = Maze.DIR_W;
		}
		/*
		console.log("---------------------")
		console.log(this.startCell.tiles[0]);
		console.log(this.endCell.tiles[0]);
		console.log("-->"+this.dir)
		*/

		// Controlla se può muoversi
		if (this.model.getNearbyCell(this.startCell, this.dir).canWalk(this.mob)) {
			//this.checking();
			if (!this.destroyed) {
				this.inProgress(this);
			}
		} else {
			// Altrimenti comunica l'esito negativo
			this.trackDone(false);
		}
	}

	checking() {
		if (!this.destroyed) {
			//requestAnimationFrame(this.checkIfReached.bind(this));
			this.checkIfReached();
		}
	}

	checkIfReached() {
		let distanceMax = 0;
		this.control.stop();
		if (this.control.goto(this.dir)) {
			// Se si è mosso incrementa la potenziale distanza percorsa
			this.traveled += this.mob.getSpeed();
		}
		if (this.dir === Maze.DIR_S) {
			// arriva da nord
			distanceMax = this.tileMap.tileh;
			//if (this.mob.mc.position().top > this.endCell.tiles[0].position().top + Math.floor((this.tileMap.tileh - this.mob.height) / 2)) {
			if (this.mob.mc.position().top > this.endCell.position().top + Math.floor((this.tileMap.tileh - this.mob.height) / 2)) {
				// Ha raggiunto la cella di destinazione
				this.trackDone(true);
				return
			}
		}
		if (this.dir === Maze.DIR_N) {
			// arriva da sud
			distanceMax = this.tileMap.tileh;
			//if (this.mob.mc.position().top < this.endCell.tiles[0].position().top + Math.floor((this.tileMap.tileh - this.mob.height) / 2)) {
			if (this.mob.mc.position().top < this.endCell.position().top + Math.floor((this.tileMap.tileh - this.mob.height) / 2)) {
				// Ha raggiunto la cella di destinazione
				this.trackDone(true);
				return
			}
		}
		if (this.dir === Maze.DIR_E) {
			// arriva da west
			distanceMax = this.tileMap.tilew;
			//if (this.mob.mc.position().left > this.endCell.tiles[0].position().left + Math.floor((this.tileMap.tilew - this.mob.width) / 2)) {
			if (this.mob.mc.position().left > this.endCell.position().left + Math.floor((this.tileMap.tilew - this.mob.width) / 2)) {
				// Ha raggiunto la cella di destinazione
				this.trackDone(true);
				return
			}
		}

		if (this.dir === Maze.DIR_W) {
			// arriva da est
			distanceMax = this.tileMap.tilew;
			//if (this.mob.mc.position().left < this.endCell.tiles[0].position().left + Math.floor((this.tileMap.tilew - this.mob.width) / 2)) {
			if (this.mob.mc.position().left < this.endCell.position().left + Math.floor((this.tileMap.tilew - this.mob.width) / 2)) {
				// Ha raggiunto la cella di destinazione
				this.trackDone(true);
				return
			}
		}
		//console.log(this.traveled , distanceMax + distanceMax / 2);
		if (this.traveled > distanceMax + distanceMax / 2) {
			// Se ha percorso "troppa" distanza vuol dire che si è incastrato da qualche parte
			this.trackDone(false);
		} else {
			// Non ha ancora raggiunto la cella di destinazione
			//this.checking();
			if (!this.destroyed) {
				this.inProgress(this);
			}
		}

	}

	
	trackDone(lEsit) {
		// Dispatcha l'esito
		if (!this.destroyed) {
			if (lEsit) {
				this.dispatch({ type: TrackHero.EVENT_MOVED });
			} else {
				this.dispatch({ type: TrackHero.EVENT_CANT_MOVE });
			}
		}
	}

}

TrackHero.DIR_N = "n";
TrackHero.DIR_E = "e";
TrackHero.DIR_S = "s";
TrackHero.DIR_W = "w";
TrackHero.DIR_NW = "nw";
TrackHero.DIR_NE = "ne";
TrackHero.DIR_SW = "sw";
TrackHero.DIR_SE = "se";
TrackHero.EVENT_CANT_MOVE = "eventCantMove";
TrackHero.EVENT_MOVED = "eventMoved";